var exports = {
  "Tn": "issueViewerContainer__i-3HrC",
  "Z5": "topContainer__forj9Q",
  "UE": "topContainerSidePanel___r9XI_",
  "Cb": "topContainerActions__yhzWEN",
  "hZ": "topContainerActionsDivider__BuHZSr",
  "Pu": "topContainerPrimaryCluster__zCC4tY",
  "dh": "topContainerNavGroup__AQBhBt",
  "bK": "topContainerLeading__9dOrqS",
  "ZB": "topContainerIssueNumber__0_SGCM",
  "FF": "topContainerTitle__HNX6kj",
  "bM": "stickyHeaderSentinel__lNt767",
  "MP": "topContainerExtras__r8yBnQ",
  "vV": "topContainerOverflowSlot__B05_G4",
  "dm": "topContainerMoreActionsSlot__8m7jFf",
  "dF": "topContainerNewSlot__yTipF3",
  "Ge": "topContainerActionGroup__PLpRzW",
  "AS": "topContainerNavControls__7LDSKL",
  "ZU": "topContainerExtrasDivider__jUwaBv",
  "qv": "topContainerChipsSlot__e9inW-",
  "_R": "topContainerChipsSlotHidden__7wty_D",
  "r7": "issueViewerMetadataPane__0TiAmC",
  "py": "metadataHeader__8bGnK5",
  "a4": "largeScreenMetadataHeader__AvBTsI",
  "jq": "crawlerPagination__jMQRW-",
  "rs": "mainContainer__O3kakG",
  "ge": "mainContainer_stickyHeader__8dbDdM",
  "M1": "contentAndSidebarWrapper__RbrYO4",
  "RR": "contentAndSidebarWrapper_viewport__0Npf5F",
  "ys": "contentAndSidebarWrapper_container__wyox_N",
  "tZ": "contentArea__-5lt60",
  "SB": "contentArea_viewport__l6BoO2",
  "Dq": "contentArea_container__1Oa891",
  "wn": "subIssuesContainer__WWUZD6",
  "eq": "subIssuesContainer_container__h5nCVz",
  "Ak": "commentsContainer__BJKxiK",
  "Ix": "metadataSidebar__R9M5UE",
  "uJ": "viewerSidePanel__1PQBhK",
  "Y2": "viewerGrid__nMhheX",
  "zm": "sidebarInfoButton__MXnGz2",
  "tl": "metadataSidebar_viewport__j6pDmg",
  "KK": "metadataSidebar_container__GjYqfx",
  "Od": "viewerGrid_viewport__THUajZ",
  "ZD": "viewerGrid_container__XuvM9p",
  "tt": "viewerTitle__gchp3l",
  "_w": "viewerContent__HzmXjP",
  "to": "viewerSidePanel_viewport__FuAeh3",
  "in": "viewerSidePanel_container__jpZv-O",
  "EM": "sidebarInfoButton_viewport__3eTOP2",
  "$2": "sidebarInfoButton_container__F0aAf8",
  "jI": "metadataDrawerBackdrop__ASxpZH",
  "LN": "metadataDrawerPanel__hDw6sZ",
  "mo": "metadataDrawerHeader__sxguH5",
  "bF": "metadataDrawerTitle__bTx2oB",
  "vx": "metadataDrawerBody__QnqUd2",
};

module.exports = exports;
